export const LANG_REGEX: RegExp = /\/([\w]{2})\//g;

const DEFAULT_LANG = "en";

export const hasLanguage = () => LANG_REGEX.test(location.pathname);

export const urlLang = () => {
  if (hasLanguage) {
    const execRegex = LANG_REGEX.exec(location.pathname);
    return execRegex?.length > 0 ? execRegex[0] : DEFAULT_LANG;
  }
  return DEFAULT_LANG;
};
